import { RidersList, FilterDataModel, RiderModel, PaymentModel, RiderFilterDataModel, SortModel, Riders_PackagesModel, Riders_PackagesAuthorizationNumberModel } from '../models/superbit-api-models'
export class RidersData {
    rider: RiderModel;
    all: RiderModel[];
    oldVersionRiders: RidersData | undefined;



    constructor(rider: RiderModel, oldVersionRiders: RidersData | undefined, all: RiderModel[]) {
        this.rider = rider;
        this.oldVersionRiders = oldVersionRiders;
        this.all = all;
    }
}

export function buildRidersTree(ridersData: RiderModel[]): RidersData[] {
        const data: RidersData[] = [];
        const subscribers = Array.from(new Set(ridersData.map((x) => x.subscriberNumber)));

        subscribers.forEach((x) => {
            if (x) {
                const subscriberRiders = ridersData.filter((y) => y.subscriberNumber === x);
                // const rider = subscriberRiders.filter((r) => r.additionNumber === 0);
                const smallestAdditionNumber = Math.min(
                    ...subscriberRiders.map(r =>
                        r.additionNumber !== undefined ? r.additionNumber : Infinity
                    )
                );
                const ridersWithSmallestAddition = subscriberRiders.filter(
                    r => (r.additionNumber !== undefined ? r.additionNumber : Infinity) === smallestAdditionNumber
                );

                if (ridersWithSmallestAddition.length > 0) {
                    // let currentRiderData = new RidersData(ridersWithSmallestAddition[ridersWithSmallestAddition.length - 1], undefined, [ridersWithSmallestAddition[ridersWithSmallestAddition.length - 1]]);
                    let currentRiderData = new RidersData(ridersWithSmallestAddition[0], undefined, [ridersWithSmallestAddition[0]]);

                    const additions = Array.from(new Set(subscriberRiders.map((x) => x.additionNumber)))
                        .sort((a, b) => (a === undefined ? 1 : b === undefined ? -1 : a - b));

                    // let newAdditions = additions.reverse();

                    additions.forEach((addition) => {
                        if (addition && addition > 0) {
                            const rider = subscriberRiders.filter((r) => r.additionNumber === addition);
                            const allVersions = subscriberRiders.filter(
                                (r) => r.additionNumber !== undefined && r.additionNumber <= addition
                            );
                            currentRiderData = new RidersData(rider[0], currentRiderData, allVersions);
                        }
                    });
                    data.push(currentRiderData);
                }
            }
        });

        return data;
    };